import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function buildReturnPath(location) {
  if (!location) {
    return '/';
  }
  return `${location.pathname || '/'}${location.search || ''}${location.hash || ''}`;
}

function normalizeRole(role) {
  return String(role || '').trim().toUpperCase().replace(/^ROLE_/, '');
}

function RequireLoginRoute({ user, authResolved = true, requiredRole, children }) {
  const location = useLocation();

  if (!authResolved) {
    return <div className="auth-loading-screen" data-testid="auth-loading-screen" role="status" aria-live="polite">Chargement…</div>;
  }

  if (user?.login) {
    if (requiredRole && normalizeRole(user.role) !== normalizeRole(requiredRole)) {
      return <Navigate to="/" replace />;
    }
    return children;
  }

  return <Navigate to="/login" replace state={{ from: buildReturnPath(location) }} />;
}

export default RequireLoginRoute;